import { Modal } from 'antd';
import React from 'react';

export interface CodeFiedProps {
  type: 'code' | 'json';
  codeStr: string;
}
const format = (code: CodeFiedProps) => {
  if (code.type === 'json') {
    try {
      return JSON.stringify(JSON.parse(code.codeStr), null, 2);
    } catch (error) {
      // console.log(error)
    }
  }
  return code.codeStr;
};
const CodeField: React.FC<CodeFiedProps> = (props: CodeFiedProps) => {
  return (
    <pre
      style={{
        padding: 16,
        overflow: 'auto',
        fontSize: '85%',
        lineHeight: 1.45,
        backgroundColor: '#f6f8fa',
        borderRadius: 3,
        width: 'min-content',
      }}
    >
      <code>{format(props)}</code>
    </pre>
  );
};

interface CodeFieldModalProps {
  visible: boolean;
  code: CodeFiedProps | undefined;
  onCancel: () => void;
}

const CodeFieldModal = (props: CodeFieldModalProps) => {
  const { onCancel, visible, code } = props;
  return (
    <Modal title="查看" onCancel={onCancel} open={visible} onOk={onCancel} width={'fit-content'}>
      <div style={{ padding: 12, maxWidth: 700, overflow: 'auto' }}>
        <CodeField type={code?.type || 'code'} codeStr={code?.codeStr || ''} />
      </div>
    </Modal>
  );
};

export default CodeFieldModal;
